export default __webpack_public_path__ + "static/media/playRoom.078edeeb.jpg";